/**
 * Helpers para scan async de campañas (opción C).
 */

const TERMINAL = ['done', 'failed'];
const DEFAULT_INTERVAL_MS = 2500;
const DEFAULT_TIMEOUT_MS = 15 * 60 * 1000;

export const extractImportStats = (payload) => {
  if (!payload) {
    return null;
  }

  if (payload.results && typeof payload.results === 'object') {
    return payload.results;
  }

  const data = payload.data || payload;
  if (data && data.results && typeof data.results === 'object') {
    return data.results;
  }

  if (data && data.scan_results) {
    try {
      return typeof data.scan_results === 'string'
        ? JSON.parse(data.scan_results)
        : data.scan_results;
    } catch (e) {
      return null;
    }
  }

  return null;
};

export const getScanStatus = (payload) => {
  if (!payload) {
    return null;
  }
  if (payload.scan_status) {
    return payload.scan_status;
  }
  const data = payload.data || payload;
  return (data && data.scan_status) ? data.scan_status : null;
};

export const isScanPending = status => (
  status === 'pending' || status === 'running'
);

/**
 * @param {Function} fetchCampaign - action redux-rest-resource (id) => Promise
 * @param {number|string} campaignId
 * @param {{ intervalMs?: number, timeoutMs?: number, onProgress?: Function }} options
 */
export const pollCampaignScan = (
  fetchCampaign,
  campaignId,
  {
    intervalMs = DEFAULT_INTERVAL_MS,
    timeoutMs = DEFAULT_TIMEOUT_MS,
    onProgress,
  } = {},
) => {
  const started = Date.now();

  return new Promise((resolve, reject) => {
    const tick = () => {
      Promise.resolve(fetchCampaign(campaignId))
        .then((res) => {
          const body = (res && res.body) || (res && res.data) || res || {};
          const campaign = body.data || body;
          const status = campaign.scan_status;
          if (typeof onProgress === 'function') {
            onProgress(status, campaign);
          }
          if (TERMINAL.indexOf(status) !== -1) {
            resolve(campaign);
            return;
          }
          if (Date.now() - started > timeoutMs) {
            reject(new Error('Timeout esperando el procesamiento del archivo'));
            return;
          }
          setTimeout(tick, intervalMs);
        })
        .catch(reject);
    };

    tick();
  });
};
